<template>
  <div class="home">
    <loading :isShow="loading" />
    <div style="padding-left: 5px">
      <div class="search-box btn3">
        <div class="input-item" style="margin-bottom:6px;">
            <span class="label">所属机构</span>
            <selectTree :clearable="false" v-model="organizationId" type="4" @change="changeOrg" ref="selectTreeRef">
            </selectTree>
        </div>
      </div>

      <Row :gutter="10">
        <Col span="6" class="box-item">
          <div>
            <div class="box-item-title">
              <span>总个人客户数(位)</span>
              <Tooltip
                max-width="100px"
                content="所属机构及其下级机构的个人客户总数"
              >
                <i class="iconfont iconwenhao1 hint"></i>
              </Tooltip>
            </div>
            <div class="box-item-sum">
              {{ numObj.totalPeople||0 }}
            </div>
            <div class="box-item-explain">
              客户总人数
            </div>
            <img
              src="../../static/images/home/client.png"
              class="box-item-icon"
              alt=""
            />
          </div>
        </Col>
        <Col span="6" class="box-item">
          <div>
            <div class="box-item-title">
              <span>总保费(元)</span>
              <Tooltip
                max-width="100px"
                content="所属机构及其下级机构出单的总保费"
              >
                <i class="iconfont iconwenhao1 hint"></i>
              </Tooltip>
            </div>
            <div class="box-item-sum">
              {{ moneyFormat("totalFee") }}
            </div>
            <div class="box-item-explain">
              历史总保费
            </div>
            <img
              src="../../static/images/home/expense.png"
              class="box-item-icon"
              alt=""
            />
          </div>
        </Col>
        <Col span="6" class="box-item">
          <div>
            <div class="box-item-title">
              <span>总收入(元)</span>
              <Tooltip
                max-width="100px"
                content="所属机构及其下级机构出单产生的属于所属机构的服务费总收入"
              >
                <i class="iconfont iconwenhao1 hint"></i>
              </Tooltip>
            </div>
            <div class="box-item-sum">
              {{ moneyFormat("totalIncome") }}
            </div>
            <div class="box-item-explain">
              预计收入
            </div>
            <img
              src="../../static/images/home/income.png"
              class="box-item-icon"
              alt=""
            />
          </div>
        </Col>
        <Col span="6" class="box-item">
          <div>
            <div class="box-item-title">
              <span>总净收入(元)</span>
              <Tooltip
                max-width="100px"
                content="所属机构及其下级机构出单产生的属于所属机构的服务费净收入"
              >
                <i class="iconfont iconwenhao1 hint"></i>
              </Tooltip>
            </div>
            <div class="box-item-sum">
              {{ moneyFormat("totalResidualIncome") }}
            </div>
            <div class="box-item-explain">历史总收入</div>
            <img
              src="../../static/images/home/generalIncome.png"
              class="box-item-icon"
              alt=""
            />
          </div>
        </Col>
      </Row>
    </div>

    <!-- 昨日数据统计 -->
    <div class="mathList hotList" style="margin-top: 10px">
      <div class="data-statistics">
        <div class="left item data-statistics-title" @click="toggleTab(1)">
          <span>昨日数据统计</span>
          <Tooltip
            max-width="100px"
            content="昨日所属机构及其下级机构的出单量、保费、由此产生的预估服务费以及新增的个人客户"
          >
            <i class="iconfont iconwenhao1 hint"></i>
          </Tooltip>
        </div>
        <div class="data-statistics-info">数据截止至昨日 24 : 00</div>
      </div>
      <div class="statistics-details">
        <div class="statistics-details-info">
          <div>较上一日</div>
          <div>昨日数据</div>
        </div>
        <div class="statistics-details-data">
          <div class="statistics-line"></div>
          <div class="statistics-details-data-title">新增保单/批单(份)</div>
          <div class="statistics-details-data-sum">
            {{ numObj.newNumber||0 }}
          </div>
          <div v-if="numObj.compareNumber==-200">-</div>
          <div v-else>
            <img
              src="../../static/images/home/goUp.png"
              v-if="numObj.compareNumber >= 0"
              alt=""
            />
            <img src="../../static/images/home/decline.png" v-else alt="" />
            <span :class="numObj.compareNumber >= 0 ? 'sum-red' : 'sum-green'"
              >{{Math.abs(parseInt(numObj.compareNumber?numObj.compareNumber:0))}}%</span
            >
          </div>
        </div>
        <div class="statistics-details-data">
          <div class="statistics-line"></div>
          <div class="statistics-details-data-title">新增保费(元)</div>
          <div class="statistics-details-data-sum">
            {{ moneyFormat("newFee") }}
          </div>
          <div v-if="numObj.compareFee==-200">-</div>
          <div v-else>
            <img
              src="../../static/images/home/goUp.png"
              v-if="numObj.compareFee >= 0"
              alt=""
            />
            <img src="../../static/images/home/decline.png" v-else alt="" />
            <span :class="numObj.compareFee >= 0 ? 'sum-red' : 'sum-green'"
              >{{Math.abs(parseInt(numObj.compareFee?numObj.compareFee:0))}}%</span
            >
          </div>
        </div>
        <div class="statistics-details-data">
          <div class="statistics-line"></div>
          <div class="statistics-details-data-title">
            预计收入(元)
          </div>
          <div class="statistics-details-data-sum">
            {{ moneyFormat("newIncome") }}
          </div>
          <div v-if="numObj.compareIncome==-200">-</div>
          <div v-else>
            <img
              src="../../static/images/home/goUp.png"
              v-if="numObj.compareIncome >= 0"
              alt=""
            />
            <img src="../../static/images/home/decline.png" v-else alt="" />
            <span :class="numObj.compareIncome >= 0 ? 'sum-red' : 'sum-green'"
              >{{Math.abs(parseInt(numObj.compareIncome?numObj.compareIncome:0))}}%</span
            >
          </div>
        </div>
        <div class="statistics-details-data">
          <div class="statistics-line"></div>
          <div class="statistics-details-data-title">
            新增客户人数(位)
          </div>
          <div class="statistics-details-data-sum">
            <!-- 假数据 -->
            {{ numObj.newPeople }}
            <!-- 1645 -->
          </div>
          <div v-if="numObj.comparePeople==-200">-</div>
          <div v-else>
            <img
              src="../../static/images/home/goUp.png"
              v-if="numObj.comparePeople >= 0"
              alt=""
            />
            <img src="../../static/images/home/decline.png" v-else alt="" />
            <span :class="numObj.comparePeople >= 0 ? 'sum-red' : 'sum-green'"
              >{{Math.abs(parseInt(numObj.comparePeople?numObj.comparePeople:0))}}% </span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 保单保费统计 -->
    <div class="premiumStatistics" style="padding-left: 5px">
      <Row :gutter="10">
        <Col span="9">
          <div class="premium-item">
            <div class="data-statistics premium-title">
              <div class="left item data-statistics-title">
                <span>人身险保单保费统计</span>
                <Tooltip
                  max-width="100px"
                  content="所属机构及其下级机构人身个险的出单量和保费"
                >
                  <i class="iconfont iconwenhao1 hint"></i>
                </Tooltip>
              </div>

              <div
                @click="
                  $router.push({
                    path: '/orderManage/insuredOrder/main',
                  })
                "
                class="look_more"
              >
                <span>查看更多</span>
                <i class="iconfont iconchakangengduojiantou fontjiantou"></i>
              </div>
            </div>
            <div>
              <Row>
                <Col span="8">
                  <div class="statistics-item">
                    <div>
                      <div class="statistics-item-sum">
                        {{ parseInt(premiumCount.allPolicyNum?premiumCount.allPolicyNum:0) }}
                      </div>
                      <div class="statistics-item-info">
                        <span v-if="userInfo.userType == 4">保单数(份)</span>
                        <span v-else>全部保单(份)</span>
                      </div>
                      <div class="premium-line"></div>
                    </div>
                    <div v-if="userInfo.userType != 4">
                      <div class="statistics-item-sum">
                        {{ premiumCount.allPayedAmount?Number(premiumCount.allPayedAmount).toLocaleString():0 }}
                      </div>
                      <div class="statistics-item-info">已支付保费(元)</div>
                      <div class="premium-line"></div>
                    </div>
                  </div>
                </Col>
                <Col span="8">
                  <div class="statistics-item">
                    <div v-if="userInfo.userType != 4">
                      <div class="statistics-item-sum">
                        {{ parseInt(premiumCount.groupPolicyNum?premiumCount.groupPolicyNum:0) }}
                      </div>
                      <div class="statistics-item-info">直属团队保单(份)</div>
                    </div>
                    <div>
                      <div v-if="userInfo.userType == 4" class="statistics-item-sum">
                        {{ premiumFormat("allPayedAmount") }}
                      </div>
                      <div v-else class="statistics-item-sum">
                        {{ premiumFormat("groupPayedAmount") }}
                      </div>
                      <div class="statistics-item-info">已支付保费(元)</div>
                      <div class="premium-line" v-if="userInfo.levelCode != 10005"></div>
                    </div>
                  </div>
                </Col>
                <Col span="8">
                  <div class="statistics-item">
                    <div>
                      <div class="statistics-item-sum">
                        {{ parseInt(premiumCount.orgPolicyNum?premiumCount.orgPolicyNum:0) }}
                      </div>
                      <div class="statistics-item-info">下级机构保单(份)</div>
                    </div>
                    <div>
                      <div class="statistics-item-sum">
                        {{ premiumFormat("orgPayedAmount") }}
                      </div>
                      <div class="statistics-item-info">已支付保费(元)</div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col span="9">
          <div class="premium-item">
            <div class="data-statistics premium-title">
              <div class="left item data-statistics-title">
                <span>团财险保单保费统计</span>
                <Tooltip
                  max-width="100px"
                  content="所属机构及其下级机构团财险的出单量和保费"
                >
                  <i class="iconfont iconwenhao1 hint"></i>
                </Tooltip>
              </div>

              <div
                @click="
                  $router.push({
                    path: '/orderManage/group/policy',
                  })
                "
                class="look_more"
              >
                <span>查看更多</span>
                <i class="iconfont iconchakangengduojiantou fontjiantou"></i>
              </div>
            </div>
            <div>
              <Row>
                <Col span="8">
                  <div class="statistics-item">
                    <div>
                      <div class="statistics-item-sum">
                        {{ parseInt(premiumCount.allGroupPolicyNum?premiumCount.allGroupPolicyNum:0) }}
                      </div>
                      <div class="statistics-item-info">
                        <span>全部保单/批单(份)</span>
                      </div>
                      <div class="premium-line"></div>
                    </div>
                    <div>
                      <div class="statistics-item-sum">
                        {{ premiumCount.allGroupPayedAmount?Number(premiumCount.allGroupPayedAmount).toLocaleString():0 }}
                      </div>
                      <div class="statistics-item-info">已支付保费(元)</div>
                      <div class="premium-line"></div>
                    </div>
                  </div>
                </Col>
                <Col span="8">
                  <div class="statistics-item">
                    <div>
                      <div class="statistics-item-sum">
                        {{ parseInt(premiumCount.groupGroupPolicyNum?premiumCount.groupGroupPolicyNum:0) }}
                      </div>
                      <div class="statistics-item-info">直属团队保单/批单(份)</div>
                    </div>
                    <div>
                      <div class="statistics-item-sum">
                        {{ premiumFormat("groupGroupPayedAmount") }}
                      </div>
                      <div class="statistics-item-info">已支付保费(元)</div>
                      <div class="premium-line"></div>
                    </div>
                  </div>
                </Col>
                <Col span="8">
                  <div class="statistics-item">
                    <div>
                      <div class="statistics-item-sum">
                        {{ parseInt(premiumCount.orgGroupPolicyNum?premiumCount.orgGroupPolicyNum:0) }}
                      </div>
                      <div class="statistics-item-info">下级机构保单/批单(份)</div>
                    </div>
                    <div>
                      <div class="statistics-item-sum">
                        {{ premiumFormat("orgGroupPayedAmount") }}
                      </div>
                      <div class="statistics-item-info">已支付保费(元)</div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="premium-item">
            <div class="data-statistics premium-title">
              <div class="left item data-statistics-title">
                <span>个人客户数</span>
                <Tooltip
                  max-width="100px"
                  content="所属机构及其下级机构的个人客户数"
                >
                  <i class="iconfont iconwenhao1 hint"></i>
                </Tooltip>
              </div>
              <div
                @click="$router.push({ 
                  path: '/customerManage/list', 
                })"
                class="look_more"
              >
                <span>查看更多</span>
                <i class="iconfont iconchakangengduojiantou fontjiantou"></i>
              </div>
            </div>
            <div>
              <Row>
                <Col span="12">
                  <div class="client-item">
                    <div>
                      <div class="client-item-sum" style="color: #236dff">
                        {{ clientCount.isSuccessCount }}
                      </div>
                      <div class="statistics-item-info">已成交客户(位)</div>
                    </div>
                    <div class="premium-line"></div>
                  </div>
                </Col>
                <Col span="12">
                  <div class="client-item">
                    <div>
                      <div class="client-item-sum" style="color: #ed0000">
                        {{ clientCount.isErrorCount }}
                      </div>
                      <div class="statistics-item-info">未成交客户(位)</div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>

    <!-- 热销 -->
    <!-- <div
      class="hotList"
      style="margin-top: 0; margin-top: 10px; margin-bottom: 15px"
    >
      <div class="data-statistics premium-title">
        <Tabs v-model="noticeTabValue" @on-click="changeNoticeTab">
          <TabPane :label="item.label" :name="item.value" v-for="(item,index) in noticeTab" :key="index"></TabPane>
        </Tabs>
        <div
          @click="$router.push({ path: '/home/chatMange', query: {} })"
          class="look_more"
        >
          <span>查看更多</span>
          <i class="iconfont iconchakangengduojiantou fontjiantou"></i>
        </div>
      </div>

      <div class="list clearfix" v-if="list && list.length > 0">
        <div
          class="left"
          @click="goDetail(list[0])"
          v-if="list[0]"
        >
          <div class="imgBox">
            <img src="../../static/images/home/notice-pic.png" />
          </div>
          <div class="textArea">
            <div class="title">{{ list[0].title }}</div>
            <div>
              <div class="tag" style="display: none">xxx</div>
              <div class="other" style="margin-top: 10px; margin-bottom: 20px">
                {{ list[0].summary }}
              </div>
            </div>

            <div class="bot">
              <div class>{{ list[0].sendTime | filterTime("YYYY-MM-DD") }}</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div
            class="item clearfix notice_item"
            v-for="(item, index) in list.slice(1, 4)"
            @click="goDetail(item)"
          >
            <div class="head">{{ item.title }}</div>
            <div class="time">
              {{ item.sendTime | filterTime("YYYY-MM-DD") }}
            </div>
          </div>
        </div>
      </div>
      <no-data v-else></no-data>
    </div> -->
  </div>
</template>
<script>
import {
  getIndexData,
  chatMangeList,
  getHolderCount,
  getAllPolicyStatistics,
} from "@/api/httpList";
import { mapState } from "vuex";
import filters from "@/api/filter";
import selectTree from '@/components/system/selectTree3';

let vm;
//当前实例组件
export default {
  components:{
    selectTree
  },
  data: () => ({
    loading: false,
    organizationId:'',
    bannerList: [],
    list: [],
    activeIndex: 1,
    value: 0,
    numObj: "",
    columns: [],
    clientCount: {
      isErrorCount: 0,
      isSuccessCount: 0,
    },
    premiumCount: {
      allPayedAmount: 0,
      allPolicyNum: 0,
      groupPayedAmount: 0,
      groupPolicyNum: 0,
      orgPayedAmount: 0,
      orgPolicyNum: 0,
      refundedAmount: 0
    },
    noticeTabValue:'1',
    noticeTab:[
      {
        label:'我的公告',
        value:'1'
      },
      {
        label:'平台公告',
        value:'2'
      },
    ]
  }),
  computed: {
    ...mapState(["userInfo"]),
    moneyFormat() {
      return (key) => filters.number_format(this.numObj[key], 2, ".", ",");
    },
    premiumFormat() {
      return (key) =>
        filters.number_format(this.premiumCount[key], 2, ".", ",");
    },
  },
  created() {
    this.organizationId = this.userInfo.organId;
    this.$nextTick(() => {
      this.$refs.selectTreeRef.openChange();
    })
  },
  methods: {
    changeNoticeTab(value) {
      if(value=='1'){
        chatMangeList({ pageNo: 1, pageSize: 4}).then((res) => {
          this.list = res.data;
        });
      }else{
        chatMangeList({ pageNo: 1, pageSize: 4, source: '2' }).then((res) => {
          this.list = res.data;
        });
      }
    },
    async getData() {
      const client_res = await getHolderCount(this.organizationId);
      this.clientCount = client_res.data;

      const premium_res = await getAllPolicyStatistics(this.organizationId);
      this.premiumCount = premium_res.data;
    },
    changeOrg() {
      this.init();
      this.getData();
    },
    goDetail(item) {
      window.open('/home/detail?id='+item.id)
      // 修改读取状态
      this.$http({
        type: "get",
        url: "/buz/noticeConfig/read/msg",
        data:{
          id:item.id
        }
      }).then(()=>{
        window.parent.postMessage({
          reloadReadNum: true,
          appMessage: true,
        }, "*");
      })
    },
    toUrl(url) {
      if (url) {
        var a = document.createElement("a");
        var event = new MouseEvent("click");
        a.href = url;
        a.target = "_blank";
        a.dispatchEvent(event);
      }
    },
    toggleTab(num) {
      this.activeIndex = num;
      this.init();
    },
    async init() {
      this.loading = true;
      const res = await getIndexData(this.activeIndex, this.organizationId);
      this.loading = false;
      this.numObj = res.data;
    },
  },
  mounted() {
    chatMangeList({ pageNo: 1, pageSize: 4 }).then((res) => {
      this.list = res.data;
    });
    const news = sessionStorage.getItem("news");
    if (news) {
      this.$router.push("/home/chatMange");
      sessionStorage.removeItem("news");
    }
    // getBannerList().then((res) => {
    //   this.bannerList = res.data;
    // });
    vm = this;
    this.columns = [
      {
        title: " ",
        align: "center",
        render(h) {
          const txt = vm.activeIndex == 1 ? "较上一日" : "较上个月";
          const txt2 = vm.activeIndex == 1 ? "昨日数据" : "本月数据";
          return (
            <div class="headeTop">
              <div>{txt2}</div>
              <div>{txt}</div>
            </div>
          );
        },
      },
      {
        title: "新增保单（份）",
        key: "name",
        align: "center",
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.compareNumber > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.compareNumber != "-200.00" &&
              parseInt(vm.numObj.compareNumber) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newNumber}</div>
                <div
                  class={{
                    rate: true,
                    up: +vm.numObj.compareNumber > 0,
                    down: +vm.numObj.compareNumber < 0,
                    gray:
                      vm.numObj.compareNumber == "-200.00" ||
                      vm.numObj.compareNumber == 0,
                  }}
                >
                  {status}
                  {vm.numObj.compareNumber == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.compareNumber) + "%"}
                </div>
              </div>
            );
          }
        },
      },
      {
        title: "新增保费（元）",
        key: "name",
        align: "center",
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.compareFee > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.compareFee != "-200.00" &&
              parseInt(vm.numObj.compareFee) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newFee}</div>

                <div
                  class={{
                    rate: true,
                    up: +vm.numObj.compareFee > 0,
                    down: +vm.numObj.compareFee < 0,
                    gray:
                      vm.numObj.compareFee == "-200.00" ||
                      vm.numObj.compareFee == 0,
                  }}
                >
                  {status}
                  {vm.numObj.compareFee == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.compareFee) + "%"}
                </div>
              </div>
            );
          }
        },
      },
      {
        key: "name",
        align: "center",
        renderHeader: (h, params) => {
          let text = "包含当前登录机构及其下级机构团队的预计收入";
          if (vm.userInfo.userType == 4) {
            text = "业务员待结算收入";
          }
          return (
            <div>
              <span>预计收入 (元)</span>
              <Poptip
                placement="top"
                transfer={true}
                trigger="hover"
                content={text}
              >
                <span
                  class="iconfont iconwenhao"
                  style="margin-left:4px;margin-top:-2px;color:#B1B5B9;font-size:14px;"
                ></span>
              </Poptip>
            </div>
          );
        },
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.compareIncome > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.compareIncome != "-200.00" &&
              parseInt(vm.numObj.compareIncome) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newIncome}</div>
                <div
                  class="rate up gray"
                  class={{
                    rate: true,
                    up: +vm.numObj.compareIncome > 0,
                    down: +vm.numObj.compareIncome < 0,
                    gray:
                      vm.numObj.compareIncome == "-200.00" ||
                      vm.numObj.compareIncome == 0,
                  }}
                >
                  {status}
                  {vm.numObj.compareIncome == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.compareIncome) + "%"}
                </div>
              </div>
            );
          }
        },
      },
      {
        key: "jsr",
        align: "center",
        renderHeader: (h, params) => {
          return (
            <div>
              <span>预计净收入 (元)</span>
              <Poptip
                placement="top"
                transfer={true}
                trigger="hover"
                content="预计收入减去下级机构团队收入后的利润"
              >
                <span
                  class="iconfont iconwenhao"
                  style="margin-left:4px;margin-top:-2px;color:#B1B5B9;font-size:14px;"
                ></span>
              </Poptip>
            </div>
          );
        },
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.compareResidualIncome > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.compareResidualIncome != "-200.00" &&
              parseInt(vm.numObj.compareResidualIncome) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newResidualIncome}</div>
                <div
                  class={{
                    rate: true,
                    up: +vm.numObj.compareResidualIncome > 0,
                    down: +vm.numObj.compareResidualIncome < 0,
                    gray:
                      vm.numObj.compareResidualIncome == "-200.00" ||
                      vm.numObj.compareResidualIncome == 0,
                  }}
                >
                  {status}
                  {vm.numObj.compareResidualIncome == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.compareResidualIncome) + "%"}
                </div>
              </div>
            );
          }
        },
      },
      {
        // title: "新增客户（位）",
        renderHeader: (h, params) => {
          let text = "客户指投保人,包括当前登录机构及下级机构团队的投保人";
          if (vm.userInfo.userType == 4) {
            text = "业务员新增投保人数";
          }
          return (
            <div>
              <span>新增客户 (位)</span>
              <Poptip transfer={true} trigger="hover" placement="top">
                <div slot="content">
                  <div>{text}</div>
                </div>
                <span
                  class="iconfont iconwenhao"
                  style="margin-left:4px;margin-top:-2px;color:#B1B5B9;font-size:14px;"
                ></span>
              </Poptip>
            </div>
          );
        },
        key: "name",
        align: "center",
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.comparePeople > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.comparePeople != "-200.00" &&
              parseInt(vm.numObj.comparePeople) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newPeople}</div>
                <div
                  class="rate up gray"
                  class={{
                    rate: true,
                    up: +vm.numObj.comparePeople > 0,
                    down: +vm.numObj.comparePeople < 0,
                    gray:
                      vm.numObj.comparePeople == "-200.00" ||
                      vm.numObj.comparePeople == 0,
                  }}
                >
                  {status}
                  {vm.numObj.comparePeople == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.comparePeople) + "%"}
                </div>
              </div>
            );
          }
        },
      },
    ];
    if (this.userInfo.userType == 4) {
      this.columns = this.columns.filter((item) => {
        return item.key != "jsr";
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./home.scss";
</style>
